import $store from '../../store'
import {getUuid} from './common'
import ObsClient from 'esdk-obs-browserjs'
import {Message} from 'element-ui'

export default function (fileDir, file, cb, isType, oldKey, fileName) { // isType ''上传  1下载 2删除
  let key = ''
  let nFileName = fileName || file.name
  let reqBack = (err, data) => {
    if (err && err.error) {
      Message.error('请求失败')
    } else if (err) {
      Message.error('请求出错')
    } else {
      if (isType === 1) {
        cb(data.InterfaceResult.Content.SignedUrl)
      } else if (isType === 2) {
        cb()
      } else {
        cb(key, nFileName)
      }
    }
  }
  let sTime = null
  let getConfig = (isLoading) => {
    if ($store.state.base.uploadTime + 30 * 60 * 1000 <= Date.now()) {
      if (!isLoading) {
        $store.dispatch('getUploadInfo') // 获取上传下载信息
        getConfig(1)
      } else {
        isLoading++
      }
      if (isLoading < 99) {
        sTime = setTimeout(() => {
          getConfig(1)
        }, 500)
      }
    } else {
      key = oldKey || getUuid()
      let config = $store.state.base.uploadSys
      if (!config) {
        sTime = setTimeout(() => {
          getConfig()
        }, 500)
      } else {
        clearTimeout(sTime)
        let obsClient = new ObsClient({
          access_key_id: config.access,
          secret_access_key: config.secret,
          security_token: config.securitytoken,
          server: 'https://obs.cn-north-4.myhuaweicloud.com'
        })
        if (isType === 1) {
          downUrl(config, obsClient)
        } else if (isType === 2) {
          delFile(config, obsClient)
        } else {
          upLoad(config, obsClient)
        }
      }
    }
  }
  let upLoad = (config, obsClient) => {
    let suffix = file.name ? file.name.replace(/.+\./, '').toLowerCase() : 'png'
    if (!oldKey) {
      key = fileDir + '/' + getUuid() + '.' + suffix
    }
    obsClient.putObject({
      Bucket: 'hrim',
      Key: key,
      Body: file,
      ACL: obsClient.enums.AclPrivate
    }, reqBack)
  }
  let downUrl = (config, obsClient) => {
    obsClient.getObject({
      Bucket: 'hrim',
      Key: file,
      SaveByType: 'file'
    }, reqBack)
  }
  let delFile = (config, obsClient) => {
    obsClient.deleteObject({
      Bucket: 'hrim',
      Key: file
    }, reqBack)
  }
  getConfig()
}



// WEBPACK FOOTER //
// ./src/assets/js/uploadFile.js